export default "__VITE_ASSET__BHAUOBAz__"